import useSWR, { SWRConfiguration } from 'swr';
import { GroupWithUsers } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useGroups(config: SWRConfiguration = {}, isPublic = false) {
    const keys = useSWRCacheKeys(!isPublic ? '/groups' : null);

    return useSWR<GroupWithUsers[]>(keys, { ...config });
}
